import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { Modal, ModalContent, ModalFooter, ModalFooterButtons, ModalHeader } from 'ui/molecules/modal';
import useClipboard from 'ui/hooks/use-clipboard';

interface NoInvestmentDocumentsCampaignModalProps {
  onClose: () => void;
  campaignLink: string;
}

const NoInvestmentDocumentsCampaignModal: FunctionComponent<NoInvestmentDocumentsCampaignModalProps> = (props) => {
  const { onClose, campaignLink } = props;
  const { copy, copied } = useClipboard();

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="issuerProductDetails.campaigns.campaignDetails.noInvestmentDocumentsModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="issuerProductDetails.campaigns.campaignDetails.noInvestmentDocumentsModal.description" />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: onClose,
            },
            {
              name: 'copyLinkToClipboard',
              content: <Translate name={`copy.link.${!copied ? 'copy' : 'copied'}`} />,
              variant: 'primary',
              disabled: copied,
              onClick: () => copy(campaignLink),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default NoInvestmentDocumentsCampaignModal;
